import { useQuery } from '@tanstack/react-query';
import { axiosPrivate } from 'app/utils';

export default function useGetPharmacyFirstServiceById({ pharmacyId, enabled = true }) {
  return useQuery({
    queryKey: ['pharmacy-first-service', pharmacyId],
    queryFn: async () => {
      try {
        const response = await axiosPrivate.get(`/v3/pharmacist/services/pharmacy-first?pharmacyId=${pharmacyId}`);
        return response.data;
      } catch (error) {
        if (error?.response?.status === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: enabled && !!pharmacyId,
    retry: (failureCount, error) => {
      if (error?.response?.status === 404) {
        return false;
      }
      return failureCount < 3;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
